<template>
  <div class="spruce-system" v-trace-click="'n.3386.6048.0'">
    <div class="header">
      <h2 class="home-model-title">云杉制度</h2>
      <a :href="pathConfig.kmsPath" target="_blank">
        <span>
          查看更多
          <i class="el-icon-arrow-right"></i>
        </span>
      </a>
    </div>
    <div class="announcement-list">
      <asideList :List="ruleList" color="#FF8C3A" />
    </div>
  </div>
</template>

<script>
import pathConfig from "@/config/requirePath";
import asideList from "@/components/aside-list";
export default {
  name: "spruce-system",
  components: {
    asideList,
  },
  data() {
    return {
      ruleList: [],
      editoStatus: false,
      sort: "",
      pathConfig,
    };
  },
  methods: {
    getRuleList() {
      _api.home.getRuleList({ size: 8 }).then((res) => {
        this.ruleList = res.data;
      });
    },
  },
  created() {
    this.getRuleList();
  },
};
</script>

<style lang="scss" scoped>
.spruce-system {
  .header {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    h2 {
      height: 16px;
      line-height: 16px;
    }
    span {
      color: #909399;
      cursor: pointer;
      line-height: 16px;
    }
  }
  .announcement-list {
    border: 1px solid rgba(237, 237, 237, 1);
    padding: 30px 20px;
    width: 285px;
    height: 314px;
  }
}
</style>
